export default {
    goods_name: '门票名称',
    goods_status: '门票状态',
    goods_type: '门票分类',
    goods_money: '金额',
    creator: '创建人',
    add_goods: '添加门票',
    goods_number: '门票编号',
    inventory: '库存',
    sales_volume: '销量',
    creation_time: '创建时间',
    shelf_time: '上架时间',
    put_away: '上架',
    sold_out: '下架',
    distribution: '分配',
    unlimited: '无限制',
    limited_inventory: '限量库存',
    goods_information: '门票信息',
    basic_price: '基础价格',
    remaining_inventory: '剩余库存',
    goods_brief: '门票简介',
    distribution_information: '分配信息',
    piece: '件',
    sub_forum_name: '分论坛名称',
    forum_status: '论坛状态',
    deadline: '截止日期',
    distribution_total_not_greater_than_inventory: '分配总量不得大于库存量',
    distribution_volume: '分配量',
    is_sale: '是否可售',
    ended: '已结束',
    in_progress: '进行中',
    distribution_total_not_greater_than_remaining_inventory: '分配总量不得大于剩余库存量',
    basic_information: '基本信息',
    detailed_description: '详细描述',
    sales_information: '销售信息',
    goods_id: '门票ID',
    goods_preview: '门票预览图',
    brief_content: '简介内容',
    sales_period: '销售时段',
    is_limited: '是否限购',
    inventory_total: '库存总数',
    per_capita_limit: '单人持票数量',
    unlimited_purchase: '不限购',
    shelf_information: '上架信息',
    not_on_the_shelf: '暂不上架',
    immediate_shelf: '立即上架',
    you_can_only_upload_image_files: '您只能上传图像文件',
    status: '状态',
    edit_price: '修改价格',
    currency: '币种',
    showSurplus: '是否显示剩余数量',
    showPrice: '是否显示金额',
    min_num: '最少购买数量',
    max_num: '最多购买数量',
    show_status: '门票公开设置',
    show_status0: '全部隐藏',
    show_status1: '全渠道可见',
    show_status2: '用户中心可见',
    show_status3: '独立渠道可见',
    unit: '单位',
    not_delete: '上架中的门票不能删除'
};
